export const types = {

	CURRENT_AUTHENTICATED_USER_REQUEST: 'CURRENT_AUTHENTICATED_USER_REQUEST',
	CURRENT_AUTHENTICATED_USER_SUCCESS: 'CURRENT_AUTHENTICATED_USER_SUCCESS',
	CURRENT_AUTHENTICATED_USER_FAILURE: 'CURRENT_AUTHENTICATED_USER_FAILURE',

	REGISTER_USER_REQUEST: 'REGISTER_USER_REQUEST',
	REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
	REGISTER_USER_FAILURE: 'REGISTER_USER_FAILURE',

	PROFILE_INFO_REQUEST: 'PROFILE_INFO_REQUEST',
	PROFILE_INFO_SUCCESS: 'PROFILE_INFO_SUCCESS',
	PROFILE_INFO_FAILURE: 'PROFILE_INFO_FAILURE',

	SIGN_IN_USER_REQUEST: 'SIGN_IN_USER_REQUEST',
	SIGN_IN_USER_SUCCESS: 'SIGN_IN_USER_SUCCESS',
	SIGN_IN_USER_FAILURE: 'SIGN_IN_USER_FAILURE',

	UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
	UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
	UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',

	LOGOUT_USER_REQUEST: 'LOGOUT_USER_REQUEST',
	LOGOUT_USER_SUCCESS: 'LOGOUT_USER_SUCCESS',
	LOGOUT_USER_FAILURE: 'LOGOUT_USER_FAILURE',

	SUBMIT_COMMENT_REQUEST: 'SUBMIT_COMMENT_REQUEST',
	SUBMIT_COMMENT_SUCCESS: 'SUBMIT_COMMENT_SUCCESS',
	SUBMIT_COMMENT_FAILURE: 'SUBMIT_COMMENT_FAILURE',

	REDIRECT_REQUEST: 'REDIRECT_REQUEST',
	CLEAN_REDIRECT_REQUEST: 'CLEAN_REDIRECT_REQUEST',

	RESET_RESPONSE_STATUS: 'RESET_RESPONSE_STATUS',

	CLEAR_ERROR: 'CLEAR_ERROR',
};
